import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25 5a1 1 0 0 0-1-1H8l-.117.007A1 1 0 0 0 8 6h.808L6.161 21H5l-.117.007A1 1 0 0 0 5 23h10v7l.007.117A1 1 0 0 0 17 30v-7h10l.117-.007A1 1 0 0 0 27 21h-1.162L23.191 6H24l.117-.007A1 1 0 0 0 25 5M10.838 6h10.323l2.647 15H8.191z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconPushPinSimple = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconPushPinSimple);
export default Memo;
